import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import Button from '../../general/inputs/Button';
import { setNotificationMessage } from '../../../redux/features/general/notification';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import CancelButton from '../../general/inputs/CancelButton';
import Popup from '../../general/popups/items/Popup';
import { resetCreateTeamMember, setEmail, setFirstName, setIsTeamMemberCreationPopupOpened, setLastName } from '../../../redux/features/hacker/users/createTeamMember';
import FormField from '../../general/inputs/FormField';
import { createTeamMember } from '../../../routes/hacker/users';
import { setIsRefreshTeamMembersList } from '../../../redux/features/hacker/users/teamMembersAccess';

interface Props { 

}; 

const CreateTeamMemberPopup: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const firstName = useAppSelector(state => state.createTeamMember.firstName); 
    const lastName = useAppSelector(state => state.createTeamMember.lastName); 
    const email = useAppSelector(state => state.createTeamMember.email); 

    // -- 

    const handleFirstName = (firstName: any) => { 

        dispatch(setFirstName(firstName));

    }; 

    // -- 

    const handleLastName = (lastName: any) => { 

        dispatch(setLastName(lastName));

    }; 

    // -- 

    const handleEmail = (email: any) => { 

        dispatch(setEmail(email));

    }; 

    // -- 

    const handleCreation = async () => { 

        if (firstName && lastName && email) { 

            const config = { 
                firstName, 
                lastName, 
                email
            }; 

            const res = await createTeamMember(config) as any; 

            if (res.data.status === 200) { 

                dispatch(setNotificationMessage('Team Member Successfully Created!'));
                dispatch(setIsRefreshTeamMembersList(true)); 
                dispatch(resetCreateTeamMember()); 

            }; 

        }; 

    }; 

    // -- 

    const handleQuit = () => { 

        dispatch(setIsTeamMemberCreationPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Popup>

            <FormField 
                icon={<AccountCircleIcon sx={{ color: colors?.firstName }} />}
                section={'firstName'}
                isFocused
                handler={handleFirstName}
            />

            <FormField 
                icon={<AccountCircleIcon sx={{ color: colors?.lastName }} />}
                section={'lastName'}
                isFocused
                handler={handleLastName}
            />

            <FormField 
                icon={<MarkEmailReadIcon sx={{ color: colors?.email }} />}
                section={'email'}
                isFocused
                handler={handleEmail}
            />

            <Button 
                title='create'
                triggerFunction={handleCreation}
                isDisabled={(!firstName || !lastName || !email) ? true : false}
                extraStyle={{ marginTop: 4, width: '50%' }}
            />

            <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

        </Popup>

  );

};

export default CreateTeamMemberPopup;